import { useRef } from 'react'
import { AchievementsHook } from './useAchievements'
import { useElementIntersectionObserver } from './useElementIntersectionObserver'

interface UseProgressBarAnimationProps {
	lastObservedStep: number
	setLastObservedStep: AchievementsHook['setLastObservedStep']
	currentStep: number
	goal: number
	achievementId: number
}

export const useProgressBarAnimation = ({
	lastObservedStep,
	setLastObservedStep,
	currentStep,
	goal,
	achievementId,
}: UseProgressBarAnimationProps) => {
	const progressRef = useRef<HTMLDivElement>(null)
	const hasAnimatedRef = useRef(false)

	useElementIntersectionObserver({
		ref: progressRef,
		disabled: hasAnimatedRef.current,
		threshold: 0.5,
		onIntersect: () => {
			const progress = progressRef.current

			if (!hasAnimatedRef.current && progress) {
				setLastObservedStep(achievementId, currentStep)
				hasAnimatedRef.current = true
				setTimeout(() => {
					progress.style.transition = 'width 0.4s ease-in-out'
					progress.style.width = `${(currentStep / goal) * 100}%`
				}, 300)
			}
		},
		onInit: () => {
			const progress = progressRef.current

			if (progress) {
				progress.style.transition = 'none'
				progress.style.width = `${(lastObservedStep / goal) * 100}%`
			}
		},
	})

	return progressRef
}
